import React, { Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import {
  Collapse,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  NavItem
} from 'shards-react';

const SignoutMenu = ({
  signOut,
  dropdownOpen,
  toggleDropdown,
  auth,
  profile,
  history,
  toggleSidebar
}) => {
  return (
    <Fragment>
      <NavItem
        tag={Dropdown}
        className='dropdown notifications'
        caret
        toggle={toggleDropdown}
      >
        <DropdownToggle caret className='text-nowrap px-3'>
          <img
            className='user-avatar rounded-circle mr-2'
            src={profile.photoURL || require('../../../assets/img/avatar.svg')}
          />
          {profile.displayName}
        </DropdownToggle>
        <Collapse tag={DropdownMenu} small open={dropdownOpen}>
          <DropdownItem tag={Link} to='/dashboard/profile'>
            Edit Profile
          </DropdownItem>
          <DropdownItem onClick={signOut}>Log Out</DropdownItem>
        </Collapse>
      </NavItem>
    </Fragment>
  );
};

export default withRouter(SignoutMenu);
